import { GA_ID } from 'config/gtmConfig';

import { PRODUCTION_URL } from 'constants/commons';
import { GTMEvents } from 'constants/enums';

import { getGDPRSettings } from './localStorage';

interface CustomWindow extends Window {
  [key: string]: any;
}

const customWindow: CustomWindow = window;
const isProduction = window.location.hostname === PRODUCTION_URL;
const blockAnalytics = !isProduction;

export type GA4CustomEventPayload = Record<string, string | number | boolean>;

export const GTMEventLogger = (
  event: GTMEvents,
  params?: GA4CustomEventPayload
): void => {
  if (!customWindow.gtag) {
    return;
  }

  if (params !== undefined && Object.keys(params).length > 0) {
    customWindow.gtag('event', event, params);

    return;
  }

  customWindow.gtag('event', event);
};

const addScript = (src: string, innerHTML?: string) => {
  const script = document.createElement('script');
  script.async = true;
  if (src) {
    script.src = src;
  }
  if (innerHTML) {
    script.innerHTML = innerHTML;
  }
  document.head.appendChild(script);
  return script;
};

const initializeGA = () => {
  if (blockAnalytics) return;

  const script = addScript(
    `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
  );
  addScript(
    '',
    `window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
    gtag('config', '${GA_ID}');`
  );

  script.onerror = (error) => {
    console.error('Failed to load Google Tag Manager script:', error);
  };
};

export const setupAnalytics = (): void => {
  const gdprSettings = getGDPRSettings();
  if (blockAnalytics) {
    return;
  }

  if (gdprSettings.F) {
    initializeGA();
  }
};
